import { combineReducers } from "redux";
import storage from "redux-persist/lib/storage";

import core from "src/reducers/reducer_core";
import userManagement from "src/reducers/reducer_user_management";
import myProfile from "src/reducers/reducer_my_profile";
import forgotPassword from "src/reducers/reducer_forgot_password";
import sidebarMenu from "src/reducers/reducer_sidebar_menu";
import listingOversight from "src/reducers/reducer_listing_oversight";
import listingReport from "src/reducers/reducer_listing_report";
import dealMonitoring from "src/reducers/reducer_deal_monitoring";
import payoutControl from "src/reducers/reducer_payout_control";
import creditScore from "src/reducers/reducer_credit_score";
import review from "src/reducers/reducer_review";
import financialLedger from "src/reducers/reducer_financial_ledger";
import subscriptionManagement from "src/reducers/reducer_subscription_management";
import listingBoost from "src/reducers/reducer_listing_boost";
import dashboard from "src/reducers/reducer_dashboard";
import witness from "src/reducers/reducer_witness";
import supportChat from "src/reducers/reducer_support_chat";

const appReducer = combineReducers({
    core,
    userManagement,
    myProfile,
    forgotPassword,
    sidebarMenu,
    listingOversight,
    listingReport,
    dealMonitoring,
    payoutControl,
    creditScore,
    review,
    financialLedger,
    subscriptionManagement,
    listingBoost,
    dashboard,
    witness,
    supportChat,
});

const rootReducer = (state, action) => {
    if (action.type === "USER_LOGOUT") {
        Object.keys(state).forEach((key) => {
            storage.removeItem(`persist:${key}`);
        });
        state = undefined;
    }

    return appReducer(state, action);
};

export default rootReducer;
